import { useMemo } from 'react';
import { Markdown as BaseMarkdown } from '@customerio/hydra-copilot/react';
import { Text } from '@customerio/pluma-components/react';
import type { Pluggable } from 'unified';
import { copilotFileRehypePlugins } from './rehype-plugins';
import { rehypeSkillHighlight } from './rehype-skill-highlight';
import '../../markdown.css';

type MarkdownProps = Omit<React.ComponentProps<typeof Text>, 'children'> & {
  children: string;
  isAnimating?: boolean;
  /** Known skill slugs — when provided, `/slug` tokens are highlighted */
  skillSlugs?: Set<string>;
};

export function Markdown({ children, isAnimating, skillSlugs, ...rest }: MarkdownProps) {
  const rehypePlugins = useMemo<Pluggable[]>(
    () =>
      skillSlugs != null && skillSlugs.size > 0
        ? [...copilotFileRehypePlugins, [rehypeSkillHighlight, skillSlugs] as Pluggable]
        : copilotFileRehypePlugins,
    [skillSlugs],
  );

  return (
    <Text flexDirection="column" gap="100" display="flex" overflowWrap="anywhere" color="active" {...rest}>
      <BaseMarkdown
        isAnimating={isAnimating}
        rehypePlugins={rehypePlugins}
        animated={{
          animation: 'customAnimation',
          duration: 120,
          easing: 'ease-in',
        }}
      >
        {children}
      </BaseMarkdown>
    </Text>
  );
}
